import { makeAutoObservable } from 'mobx';
import AlertStore from './Alert';
import goxApi from 'api/gox-api';

class User {

  id = null;
  phone = null;
  email = null;
  bonusBalance = 0;
  mainBalance = 0;
  refillPlans = [];
  turboEnabled = false;
  subscribed = false;

  latitude = null;
  longitude = null;
  locationPermission = null;
  lastLocationUpdate = null;

  constructor() {
    makeAutoObservable(this);
  }  

  async fetch() {
    try {
      const { user } = await goxApi.users();
      this.applyData(user);
    } catch (err) {
      console.log('catcj', err);
      // AlertStore.add(err.message);
    }
  }

  applyData(user) {
    this.id = user.id;
    this.phone = user.phone;
    this.email = user.email;
    this.bonusBalance = user.bonus_balance;
    this.mainBalance = user.main_balance;
    this.refillPlans = user.refill_plans ?? [];
    this.turboEnabled = user.turbo_enabled;
    this.subscribed = user.subscribed;
  } 

  getLocation() {
    window.navigator?.geolocation?.getCurrentPosition(this.onGotLocation.bind(this), this.onLocationError.bind(this));
  }

  onLocationError(err) {
    AlertStore.add(err.message);
    this.locationPermission = 'denied';
  }

  onGotLocation(position) {    
    this.latitude = position?.coords?.latitude ?? null;
    this.longitude = position?.coords?.longitude ?? null;
    this.locationPermission = 'granted';
    this.lastLocationUpdate = new Date();
  }

  async hasCard() {
    return new Promise(async (resolve, reject) => {
      try {
        await goxApi.hasCard();
        resolve({success: true});
      } catch (err) {
        if (err.message && err.message.toLowerCase() === 'user has no cards.') {
          return resolve({success: false, message: 'To make your ride you should update payment method.'});
        }
  
        if (err.message && err.message.toLowerCase() === 'we were not able to collect funds for your previous ride. please update payment method.') {
          return resolve({success: false, message: err.message});
        }

        // unknown response: could be a server error rather than a missing
        // card — surface it instead of silently re-asking for a payment method
        if (err.message) {
          AlertStore.add(err.message);
        }
        resolve({success: false});
      }
    })
  }

}

const UserStore = new User();
export default UserStore;
